import FileDownload from './FileDownload';

export default FileDownload;



// WEBPACK FOOTER //
// ./src/components/FileDownload/index.js